/**
 * Block B.9: экран «бот недоступен» — показывается при 401/403 от API.
 *
 * Возможные причины:
 * - Партнёр поставил бота на паузу или удалил.
 * - Аккаунт клиента заблокирован системой.
 * - JWT истёк и WebApp нужно перезайти.
 *
 * UX: явная карточка с emoji + объяснением + CTA «Связаться с поддержкой» (если
 * support_url задан в branding партнёра — но мы не знаем какой, так что fallback
 * на @support).
 */

import { useTranslation } from 'react-i18next';
import { Bot } from 'lucide-react';
import { StateScreen } from '@/components/StateScreen';
import { Btn } from '@/components/ui/tiles';
import { getWebApp } from '@/lib/telegram';

export function BotDisabledScreen() {
  const { t } = useTranslation();

  const handleClose = () => {
    const tg = getWebApp();
    tg?.close();
  };

  return (
    <StateScreen icon={<Bot />} tone="danger" title={t('Disabled title')} description={t('Disabled description')}>
      <Btn className="w-full" onClick={handleClose}>
        {t('Disabled close')}
      </Btn>
    </StateScreen>
  );
}
